export default __webpack_public_path__ + "static/media/5.4067b7c1.jpeg";